import classNames from 'classnames';
import React, { Component } from 'react';
import './Header.css';

// Props
// header: string;
// subHeader: string;
// timeRemaining?: string;
// classNames?: string;
// hideOnMobile?: boolean;
// isCustomBooking?: boolean;

export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      flashy: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.subHeader !== this.props.subHeader) {
      this.setState({
        flashy: false
      }, () => {
        this.setState({
          flashy: true
        });
      });
    }
  }

  render() {
    const messageClasses = classNames('Header-message', {
      'Header-message--flashy': this.state.flashy && !this.props.isCustomBooking
    });
    const headerClasses = classNames('Header', this.props.classNames);
    const headerTopBarClasses = classNames('Header-topBar', {
      'Header-topBar--hide': this.props.hideOnMobile
    });

    return (
      <div className={headerClasses}>
        <div className={headerTopBarClasses}>
          <a href={`${process.env.PUBLIC_URL}`}>
            <img alt={'Logo'} className={'Header-logo'} src={'https://storage.googleapis.com/ctrlv-www/wp-uploads/2016/11/PNG-Ctrl-V.png'} />
          </a>
          <div className={'Header-timer'}>{this.props.timeRemaining}</div>
        </div>
        <div className={messageClasses} key={Math.random()}>
          <div className={'Header-flash'}>{}</div>
          <div className={'Header-header'}>{this.props.header}</div>
          <div className={'Header-subHeader'}>{this.props.subHeader}</div>
        </div>
      </div>
    );
  }
}
